import { Suspense } from "react";
import { useSelector } from "react-redux";
import SbLoading from "../../components/common/SbLoading";
import { Route, Redirect, useLocation } from "react-router-dom";

const CashierPrivateRoute = ({ component: Component, ...rest }) => {
  const location = useLocation();
  const isCashierAuthenticated = useSelector(
    (state) => state.cashierRoot.isAuthenticated
  );

  const cashierBaseUrl = location?.pathname?.split("/")?.[1];
  const storeIdFromUrl = location?.pathname?.split("/")?.[2];

  const isCashierPrivateRoutes =
    cashierBaseUrl === "cashier-home" ||
    cashierBaseUrl === "cashier-history" ||
    cashierBaseUrl === "redeem-reward";

  const storeId =
    localStorage?.storeId ?? (isCashierPrivateRoutes ? storeIdFromUrl : false);

  return (
    <Route
      {...rest}
      render={(props) =>
        isCashierAuthenticated ? (
          <Suspense fallback={<SbLoading fullPage={true} />}>
            <Component {...props} />
          </Suspense>
        ) : storeId ? (
          <Redirect to={`/cashier/${storeId}`} />
        ) : (
          <Redirect to={"/cashier-store-id-not-found"} />
        )
      }
    />
  );
};

export default CashierPrivateRoute;
